import React from 'react'
import Button from '../../components/atoms/Button';

const ModalCaraTF = ({show, title, content, actClose}) => {
    return (
        <div className={`kc-modal ${!show && 'kc-modal-hiden'}`}>
            <div className='kc-modal-dialog'>
                <button type="button" className="kc-modal-close" onClick={actClose}>
                    <span aria-hidden="true">&times;</span>
                </button>
                
                <div className='kc-modal-content'>
                    <h1>{title}</h1>
                    {typeof content === 'string' ? <p>{content}</p> : content }
                </div>
            </div>
        </div>
    )
}

export default ModalCaraTF;